import { PhoneNumberFormat } from './enums'

const COUNTRY_CODE_CA = '1';

export class PhoneNumberFormatter {

  // Format a phone number to a particular standard
  public static format(rawPhoneNumber: string, numberFormat: PhoneNumberFormat): string {
    if (!rawPhoneNumber) return;
    // Get 10-digit number only without leading country codes
    let digitString = this._extractDigits(rawPhoneNumber);
    digitString = this._trimLeadingCountryCode(digitString, COUNTRY_CODE_CA);

    if (digitString.length === 0) {
      return null;
    }

    switch (numberFormat) {
      case PhoneNumberFormat.HYPHENS:
        return this._formatHyphens(digitString);
      case PhoneNumberFormat.CA_NATIONAL:
        return this._formatCaNational(digitString);
      case PhoneNumberFormat.RFC3966:
        return this._formatRFC3966(digitString, COUNTRY_CODE_CA);
      default:
        return digitString;
    }
  }

  private static _extractDigits(rawPhoneNumber: string): string {
    const numbers = rawPhoneNumber.match(/\d/g);
    return numbers.join('');
  }

  // Trims a leading country code if applicable
  private static _trimLeadingCountryCode(digitString: string, countryCode: string): string {
    const countryCodeLength = countryCode.length;
    // If the exact number of extra digits is the country code length
    if (digitString.length === (10 + countryCodeLength) && digitString.substring(0, countryCodeLength) === countryCode) {
      return digitString.substring(countryCodeLength);
    }
    return digitString;
  }

  private static _getDigitGroups(digitString: string): RegExpMatchArray {
    return digitString.match(/^(\d{3})(\d{3})(\d{4})$/);
  }

  // Format with simple hyphens 123-456-7890
  private static _formatHyphens(digitString: string): string {
    const subMatches = this._getDigitGroups(digitString);
    return (!subMatches) ? digitString : subMatches[1] + '-' + subMatches[2] + '-' + subMatches[3];
  }

  // Format number to CA national (123) 456-7890
  private static _formatCaNational(digitString: string): string {
    const subMatches = this._getDigitGroups(digitString);
    return (!subMatches) ? digitString : '(' + subMatches[1] + ') ' + subMatches[2] + '-' + subMatches[3];
  }

  // Format number to RFC3966 tel:+13214567890
  private static _formatRFC3966(digitString: string, countryCode: string): string {
    return 'tel:+' + countryCode + digitString;
  }

}
